import { z } from 'zod'
import { UserRole } from '@/core/domain/resources/enums/UserRole'
import { UserGender } from '@/core/domain/resources/enums/UserGender.ts'
import { UserBirthdateSchema } from '@/core/infrastructure/schemas/utils/UserBirthdateSchema.ts'

/**
 * Schéma de validation pour un membre éducatif disponible
 */
export const AvailableEducationalMemberSchema = z.object({
  identifier: z.string().uuid(),
  firstname: z.string().min(1, 'Le prénom est requis'),
  lastname: z.string().min(1, 'Le nom est requis'),
  username: z.string().min(1, "Le nom d'utilisateur est requis"),
  email: z.string().email("L'email doit être valide"),
  roles: z.array(z.nativeEnum(UserRole.SchoolValues)),
  gender: z.nativeEnum(UserGender.Values),
  birthdate: UserBirthdateSchema.nullable(),
})

/**
 * Type TypeScript déduit du schéma
 */
export type AvailableEducationalMemberEntity = z.infer<typeof AvailableEducationalMemberSchema>

/**
 * Schéma pour un tableau de membres éducatifs disponibles
 */
export const AvailableEducationalMemberArraySchema = z.array(AvailableEducationalMemberSchema)
